(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Sequency", [], factory);
	else if(typeof exports === 'object')
		exports["Sequency"] = factory();
	else
		root["Sequency"] = factory();
})(self, () => {
return 